import { ActionsEnum, UserStatusEnum } from 'src/shared/enums';
import { CenterRolesEnum, CenterStatusEnum } from 'src/shared/enums';
import {
  IAction,
  ICenter,
  ICenterRequest,
  ICompletedUser,
  ICompletedProfile,
  IUser,
  IConsumableParams,
} from 'src/shared/models';
import { config } from 'config/config';
import { PlatformEnum } from 'src/shared/enums';

const { EMPLOYEE, MANAGER } = CenterRolesEnum;

const {
  ACCEPTED_EMPLOYEE,
  ACCEPTED_MANAGER,
  HCP_NOT_VALIDATED,
  MANAGER_NOT_VALIDATED,
  STAFF_NOT_VALIDATED,
  NO_CENTER,
} = UserStatusEnum;

export const myPointsStatus = [
  ACCEPTED_EMPLOYEE,
  ACCEPTED_MANAGER,
  MANAGER_NOT_VALIDATED,
  HCP_NOT_VALIDATED,
  STAFF_NOT_VALIDATED,
  NO_CENTER,
];

export const ordersStatus = [ACCEPTED_EMPLOYEE, ACCEPTED_MANAGER, NO_CENTER];

export const centerProfileStatus = [ACCEPTED_MANAGER, ACCEPTED_EMPLOYEE];

export const centerMembersStatus = [ACCEPTED_MANAGER];

export const myInvoicesStatus = [ACCEPTED_MANAGER];

export const redeemPointStatus = [
  ACCEPTED_EMPLOYEE,
  ACCEPTED_MANAGER,
  NO_CENTER,
];

export const myProfileStatus = [
  ACCEPTED_EMPLOYEE,
  ACCEPTED_MANAGER,
  STAFF_NOT_VALIDATED,
  NO_CENTER,
];

export const eventsStatus = [ACCEPTED_EMPLOYEE, ACCEPTED_MANAGER];

export const requestOrderStatus = [ACCEPTED_EMPLOYEE, ACCEPTED_MANAGER];

export const getValidCenter = (
  requests: ICenterRequest[],
): { idCenter?: ICenter; role?: CenterRolesEnum } => {
  if (!requests?.length) return;

  const { idCenter, idRole } = requests[0];

  if (!idCenter || !idRole) return;

  const { centerStatus, idSalesforce, status } = idCenter;

  if (!idSalesforce || !status || centerStatus !== CenterStatusEnum.GRANT)
    return;

  const role = idRole === MANAGER || idRole === EMPLOYEE ? idRole : null;

  return { idCenter, role };
};

export const isManager = (userStatus: UserStatusEnum) => {
  return userStatus === ACCEPTED_MANAGER;
};

export const checkProfileCompletion = (user: IUser) => {
  const currentUserPharmacy: ICompletedProfile = {
    name: user?.salesforce?.userFirstname,
    lastName: user?.salesforce?.userSurname,
    phone: user?.salesforce?.userPhone,
    birthday: user?.salesforce?.userBirthdate,
    gender: user?.salesforce?.userGender,
    pharmacy: user?.salesforce?.sapCustomerId,
  };

  const currentUser: ICompletedUser = {
    name: user?.salesforce?.userFirstname,
    lastName: user?.salesforce?.userSurname,
    phone: user?.salesforce?.userPhone,
    birthday: user?.salesforce?.userBirthdate,
    gender: user?.salesforce?.userGender,
  };

  const { PLATFORM } = config.APP;

  const profileValues = Object.values(
    PLATFORM === PlatformEnum.CON_SPAIN ? currentUserPharmacy : currentUser,
  );
  const filledInValues: number = profileValues.filter((value) => value).length;
  const progress = (filledInValues * 100) / profileValues.length;

  return progress;
};

export const isProfileCompleted = (actionList: ActionsEnum[]): boolean => {
  if (actionList === undefined) {
    return true;
  }
  const profileAction = actionList?.find(
    (action) => action === ActionsEnum.COMPLETE_PROFILE,
  );

  return Boolean(profileAction);
};

export const getProfileCompletedPoints = (actions: IAction[]) => {
  return actions?.find((item) => item.action === ActionsEnum.COMPLETE_PROFILE)
    ?.points;
};

export const isConsumableActive = (consumable?: IConsumableParams) => {
  return consumable?.active;
};
